import React from 'react';
import {BooleanField, Datagrid, Filter, List, SelectInput, TextField, TextInput} from 'react-admin';
import {schoolYears} from "../../components";

const MonTuChonFilter = (props) => (
    <Filter {...props} >
        <TextInput label="ra.action.search" source="q" alwaysOn/>
        <SelectInput label="resources.schoolYears.name" source="schoolYear" choices={schoolYears}
                     alwaysOn allowEmpty={false}
        />
    </Filter>
);

export const AdmissionCategoryList = props => (
    <List filters={<MonTuChonFilter/>}
          exporter={false} bulkActions={false}
          filterDefaultValues={{schoolYear: schoolYears != null && schoolYears.length > 0 ? schoolYears[0].id : null}} {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="name"/>
            <BooleanField source="active"/>
        </Datagrid>
    </List>
);

export default AdmissionCategoryList
